import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ECharts } from "echarts";
import { from, fromEvent } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { CommonService } from "../../service/common.service";
import { MultiLineChartService } from "./multi-line-chart.service";
import { initOpts } from '../../config/initOpts';
import { ChartResizeService } from '../../service/chart-resize.service';
import * as color from '../../config/colors';
import * as backgroundColor from '../../config/backgroundColor';
import { ChartDarkModeService } from '../../service/chart-dark-mode.service';
import { axisLabelRotate } from './multi-line-chart-param-interface';
import { isNil } from 'lodash'

@Component({
  selector: "bcac-multi-line-chart",
  templateUrl: "./multi-line-chart.component.html",
  styleUrls: ["./multi-line-chart.component.scss"],
})
export class MultiLineChartComponent implements OnInit {
  constructor(
    private commonService: CommonService,
    private multiLineChartService: MultiLineChartService,
    private chartResizeService: ChartResizeService,
    private chartDarkModeService: ChartDarkModeService
  ) { }

  initOpts;
  defaultEchartOption: any = this.multiLineChartService.getDefaultOption();
  ngOnInit() {
    this.initOpts = initOpts;
    this.initEchart();
    fromEvent(window, "resize")
      .pipe(debounceTime(200))
      .subscribe(() => {
        this.chartResizeService.autoResizeAdapt(this.optionInit, this.options);
      });
  }

  optionInit: ECharts;
  onOptionInit(ec) {
    this.optionInit = ec;
  }

  intervalDatas = [];
  intervalSelectedData;
  intervalSelectedDataChange(e: any) {
    // 跟新图表interval
    this.multiLineChartService.setInterval(this.defaultEchartOption, e);
    this.updateOption();
  }

  axisScaleChange(e: any) {
    this.multiLineChartService.setInterval(this.defaultEchartOption, e);
    this.updateOption();
  }

  singleSelectIconShow: boolean = false; //interval选择按钮是否显示
  @Input()
  set bcacIntervalDatas(value: any[]) {
    if (Array.isArray(value) && value.length > 0) {
      this.intervalDatas = value;
      this.singleSelectIconShow = true;
      if (value.length == 1) {
        this.axisScaleChange(value[0].value);
        this.singleSelectIconShow = false;
      }
    } else {
      this.singleSelectIconShow = false;
    }
  }
  radioValue;

  chartTitle = {
    show: true,
    label: "图表名称",
  };
  @Input()
  set bcacTitle(value: string) {
    this.chartTitle.show = true;
    this.chartTitle.label = value;
  }
  @Input()
  set bcacCloseTitle(value: boolean) {
    this.chartTitle.show = false;
  }

  _unit;
  @Input()
  set bcacUnit(value: string) {
    this._unit = value;
    this.multiLineChartService.setUnit(this.defaultEchartOption, value);
    this.updateOption();
  }

  @Input()
  set bcacXaxisLabelRotate(xAxisLabelRotate: axisLabelRotate) {
    this.multiLineChartService.changeXaxisLabelRotate(this.defaultEchartOption, xAxisLabelRotate);
  }

  @Input() 
  set bcacYaxisLabelRotate(yAxisLabelRotate: axisLabelRotate) {
    this.multiLineChartService.changeYaxisLabelRotate(this.defaultEchartOption, yAxisLabelRotate);
  }

  @Input()
  set bcacXaxisLabelFormat(xAxisLabelFormat: number[]) {
    this.multiLineChartService.setXaxisLabelFormat(this.defaultEchartOption, xAxisLabelFormat);
  }


  @Input()
  set bcacXaxisName(value: string) {
    this.multiLineChartService.setXaxisName(this.defaultEchartOption, value);
    this.updateOption();
  }

  @Input()
  set bcacYaxisName(value: string) {
    this.multiLineChartService.setYaxisName(this.defaultEchartOption, value);
    this.updateOption();
  }

  @Input()
  set bcacYnameGap(value: number) {
    this.multiLineChartService.setYnameGap(this.defaultEchartOption, value);
    this.updateOption();
  }
  sName = [];
  value;
  @Input()
  set bcacDatas(value: any) {
    this.sName = [];
    this.value = value;
    let legendDataArr = [];
    if (value && value.hasOwnProperty('seryNames') && !isNil(value.seryNames)) {
      value.seryNames.forEach(e => {
        let sName = e.split("(").length == 1 ? e : e.split("(")[0];
        if (e.split("(").length == 2) {
          this.sName.push(e.split("(")[1].split(")")[0]);
        }
        legendDataArr.push(
          {
            label: sName,
            value: sName,
            checked: true
          }
        );
      });
    }
    this.defaultEchartOption.tooltip = this.multiLineChartService.sNameValue.getToolTipOfAxisChart(this.multiLineChartService.style, "", this.sName);
    this.legendDataArr = legendDataArr;
    this.multiLineChartService.setDatas(this.defaultEchartOption, value);
    if (this.isDarkMode === true) {
      this.chartDarkModeService.openDarkMode(this.defaultEchartOption, this.isDarkMode);
    }
    if (this.chartColors.length > 0) {
      this.defaultEchartOption.color = this.chartColors;
    }
    if (this.isOpenAreaStyle) {
      this.defaultEchartOption.series.forEach(e => {
        e['areaStyle'] = {};
      });
    }
    if (this._dimensionNames) {
      this.multiLineChartService.changeDimensionNames(this.defaultEchartOption, this._dimensionNames, this._unit)
    }
    this.updateOption();
  }
  _dimensionNames;
  // 设置dimension名称
  @Input()
  set bcacDimensionNames(dimensionNames: string[]) {
    this._dimensionNames = dimensionNames;
    this.multiLineChartService.changeDimensionNames(this.defaultEchartOption, dimensionNames, this._unit)
  }

  legendChange(e) {
    this.multiLineChartService.topLegendChange(e, this.optionInit);
  }

  legendDataArr = [];

  dataSourceSelectData = [];
  @Input()
  set bcacDataSourceList(value: any[]) {
    this.dataSourceSelectData = value;
  }

  // 加载等待
  _bcacChartLoading: boolean = false;
  @Input()
  set bcacChartLoading(chartLoading: boolean) {
    this._bcacChartLoading = chartLoading;
  }

  //Y轴min
  @Input()
  set bcacYAxisMin(min: number) {
    this.multiLineChartService.changeYAxisMin(this.defaultEchartOption, min);
    this.updateOption()
  }
  @Input()
  set bcacYAxisMax(max: number) {
    this.multiLineChartService.changeYAxisMax(this.defaultEchartOption, max);
    this.updateOption()
  }
  @Input()
  set bcacYAxisInterval(interval: number) {
    this.multiLineChartService.changeYAxisInterval(this.defaultEchartOption, interval);
  }
  @Output()
  bcacDataSourceSelectEmit = new EventEmitter<any>();
  dataSourceChange(e: any) {
    this.bcacDataSourceSelectEmit.emit(e);
  }

  options;
  // echart配置项
  initEchart() {
    this.options = this.defaultEchartOption;
  }

  updateOption() {
    if (this.optionInit) {
      this.optionInit.setOption(this.options, true);
    }
  }

  legendPosition = "right"; // 支持可选right，bottom，top
  @Input()
  set bcacLegendPosition(value: string) {
    this.legendPosition = value;
    this.multiLineChartService.setLegendPosition(this.defaultEchartOption, this.legendPosition);
    this.updateOption();
  }

  customToolBoxRightPosition = "3.5rem";
  @Input()
  set bcacCustomToolBoxRightPosition(value: string) {
    this.customToolBoxRightPosition = value;
  }

  isSmallMode: boolean = false;
  @Input()
  set bcacSmallMode(smallMode: boolean) {
    if (smallMode) {
      this.isSmallMode = true;
      this.changeCardPadding("0rem");
      this.chartResizeService.openSmallMode(this.defaultEchartOption, this.isSmallMode, this.legendPosition);
      // this.chartResizeService.configSplitLine(false, this.defaultEchartOption);
      this.updateOption();
    } else {
      this.isSmallMode = false;
    }
  }

  @Input()
  set bcacAxisSplitLine(axisSplitLineShow: boolean) {
    if (axisSplitLineShow == true) {
      this.chartResizeService.configSplitLine(true, this.defaultEchartOption);
    } else {
      this.chartResizeService.configSplitLine(false, this.defaultEchartOption)
    }
  }

  cardPadding = "1rem";
  changeCardPadding(cardPadding: string) {
    this.cardPadding = cardPadding;
  }

  isDarkMode: boolean | string = false;
  @Input()
  set bcacDarkMode(darkMode: boolean) {
    this.isDarkMode = darkMode;
    this.changeChartTitleColor(darkMode);
    this.changeCardBackgroundColor(darkMode);
    this.chartDarkModeService.openDarkMode(this.defaultEchartOption, darkMode);
    this.updateOption();
  }
  chartTitleColor = '';
  changeChartTitleColor(darkMode: boolean | string) {
    if (!darkMode) {
      this.chartTitleColor = ''
    } else {
      this.chartTitleColor = color.darkModeTextColor;
    }
  }
  cardBgColor = "#fff";
  changeCardBackgroundColor(darkMode: boolean | string) {
    if (typeof (darkMode) === 'string') {
      this.cardBgColor = darkMode;
    } else if (darkMode) {
      this.cardBgColor = backgroundColor.darkModeBGColor;
    }
  }

  chartColors: string[] = [];
  @Input()
  set bcacColors(value: string[]) {
    this.chartColors = value;
    this.defaultEchartOption.color = value;
    this.updateOption();
  }

  @Input()
  set bcacYAxisMinInterval(minInterval: number) {
    this.multiLineChartService.changeYAxisMinInterval(minInterval, this.defaultEchartOption);
  }

  isOpenAreaStyle: boolean = false;
  @Input()
  set bcacOpenAreaStyle(value: boolean) {
    this.isOpenAreaStyle = value;
    if (this.isOpenAreaStyle) {
      this.defaultEchartOption.series.forEach(e => {
        e['areaStyle'] = {};
      });
    }
  }

}
